declare const INTEGRATION_MODE: string;

export const INTEGRATION_MODES = {
  NONE: 'none',
  SEMRUSH: 'semrush',
  RESPONA_APP: 'respona_app',
  RESPONA_CONCIERGE: 'respona_concierge',
  RESPONA_PUBLISHER: 'respona_publisher',
};

export const isSemrushMode = (): boolean =>
  INTEGRATION_MODE.toLowerCase() === INTEGRATION_MODES.SEMRUSH;

export const isStandaloneMode = (): boolean =>
  INTEGRATION_MODE.toLowerCase() === INTEGRATION_MODES.NONE ||
  INTEGRATION_MODE.toLowerCase() === INTEGRATION_MODES.RESPONA_APP ||
  INTEGRATION_MODE.toLowerCase() === INTEGRATION_MODES.RESPONA_CONCIERGE ||
  INTEGRATION_MODE.toLowerCase() === INTEGRATION_MODES.RESPONA_PUBLISHER;
